import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteOfferBypassRegionFilterSetting } from '~/services/PromoService';

import { offerBypassRegionFilterQueryKeys } from './offerBypassRegionFilterQueryKeys';

export function useDeleteOfferBypassRegionFilterSetting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteOfferBypassRegionFilterSetting(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerBypassRegionFilterQueryKeys.lists() });
    },
  });
}
